import React from 'react';

const FiscalYearContext = React.createContext();

export default FiscalYearContext;
